import { FEATURES, type FeatureKey } from './registry';

const envCache = new Map<string, boolean>();

function readEnvVar(varName: string): boolean | undefined {
  const raw = (import.meta.env as Record<string, string | undefined>)[varName];
  if (raw === undefined) return undefined;
  return raw === 'true' || raw === '1';
}

export function isEnvEnabled(featureKey: FeatureKey): boolean {
  if (envCache.has(featureKey)) return envCache.get(featureKey)!;

  const def = FEATURES[featureKey];
  if (!def.envVar) {
    envCache.set(featureKey, def.defaultEnabled);
    return def.defaultEnabled;
  }

  const envValue = readEnvVar(def.envVar);
  const result = envValue ?? def.defaultEnabled;
  envCache.set(featureKey, result);
  return result;
}
